export default "__VITE_ASSET__839941d0__"